import { useApi } from "@/lib/api";
import { ArticleCard } from "@/components/site/ArticleCard";
import { SectionHeading } from "@/components/site/SectionHeading";

const mainCategory = (cats) => {
  const list = Array.isArray(cats) ? cats : [];
  return list.find((c) => c !== "News") || list[0] || "News";
};

export const RelatedArticles = ({ article }) => {
  const category = mainCategory(article?.categories);
  const { data } = useApi("/news", { category, limit: 4 });
  const { data: latest } = useApi("/news", { limit: 7 });
  const seen = new Set([article?.slug]);
  const items = [...(Array.isArray(data) ? data : []), ...(Array.isArray(latest) ? latest : [])]
    .filter((n) => !seen.has(n.slug) && seen.add(n.slug))
    .slice(0, 3);
  if (items.length === 0) return null;
  return (
    <section className="mt-28 border-t border-white/10 pt-16" data-testid="related-articles">
      <SectionHeading top="À lire" bottom="aussi" testId="related-articles-title" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16 mt-12" data-testid="related-articles-grid">
        {items.map((n, i) => <ArticleCard key={n.id} item={n} index={i} prefix="news" />)}
      </div>
    </section>
  );
};
